var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99808 13.3821H7.49808V13.8821V23.5H3.49615V13.8821V13.3821H2.99615H0.551669L0.948361 9.35474H2.99615H3.49615V8.85474V6.31579C3.49615 4.77173 4.10342 3.29191 5.18277 2.20162C6.26195 1.1115 7.72456 0.5 9.24856 0.5H12.5V4.55263H9.24856C8.78266 4.55263 8.33688 4.73963 8.009 5.07084C7.68129 5.40187 7.49808 5.84979 7.49808 6.31579V8.85474V9.35474H7.99808H12.4483L12.0516 13.3821H7.99808Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookwhite);
export default __webpack_public_path__ + "static/media/facebookwhite.5548626a38f5f7763fa9d2ee35984c23.svg";
export { ForwardRef as ReactComponent };